const IconMoneyBillWave = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="63.001"
			height="49.5"
			viewBox="0 0 63.001 49.5"
		>
			<defs>
				<filter
					id="a"
					x="0"
					y="0"
					width="63.001"
					height="49.5"
					filterUnits="userSpaceOnUse"
				>
					<feOffset dy="3" input="SourceAlpha" />
					<feGaussianBlur stdDeviation="3" result="b" />
					<feFlood flood-opacity="0.161" />
					<feComposite operator="in" in2="b" />
					<feComposite in="SourceGraphic" />
				</filter>
			</defs>
			<g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#a)">
				<path
					d="M43.675,3.829A20.822,20.822,0,0,0,35.49,2.25c-8.66,0-17.32,4.383-25.98,4.383A21.333,21.333,0,0,1,3,5.669a2.4,2.4,0,0,0-.728-.114A2.237,2.237,0,0,0,0,7.791V30.1A2.236,2.236,0,0,0,1.325,32.17,20.81,20.81,0,0,0,9.51,33.75c8.66,0,17.321-4.384,25.981-4.384a21.333,21.333,0,0,1,6.514.965,2.4,2.4,0,0,0,.728.114A2.237,2.237,0,0,0,45,28.208V5.9a2.239,2.239,0,0,0-1.325-2.072ZM22.5,24.75c-3.107,0-5.625-3.023-5.625-6.75s2.519-6.75,5.625-6.75,5.625,3.022,5.625,6.75S25.606,24.75,22.5,24.75Z"
					transform="translate(9 3.75)"
					fill="#fff"
				/>
			</g>
		</svg>
	)
}

export default IconMoneyBillWave